import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "../../services/queryClient";
import { getToken } from "../../utils/getToken";

type Customer = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
};

export const useCreateCustomersMutation = () => {
  const token = getToken();
  return useMutation({
    mutationFn: (payload: Customer) =>
      axiosInstance
        .post("/customers", payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      queryClient.invalidateQueries({ queryKey: ["useGetCustomerQuery"] });
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
